import React from "react";

const LeftSideBarCounter = () => {
    return (
        <svg width="150" height="55" viewBox="0 0 150 55" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 7H150C150 3.13401 146.866 0 143 0H7V7Z" fill="#C9D7D8" />
            <rect width="132" height="11" transform="matrix(1 0 0 -1 18 18)" fill="#4A5353" />
            <path d="M25 25H143C146.866 25 150 21.866 150 18H25V25Z" fill="#C9D7D8" />
            <path d="M7 0L7 55C3.13401 55 0 51.866 0 48L0 7C0 3.13401 3.13401 0 7 0Z" fill="#C9D7D8" />
            <path d="M18 7L18 55H7L7 7L18 7Z" fill="#4A5353" />
            <path d="M25 18L25 48C25 51.866 21.866 55 18 55L18 18H25Z" fill="#C9D7D8" />
        </svg>
    )
}
export default LeftSideBarCounter;